export default "__VITE_ASSET__NfrwpBYf__"